<template>
  <div id="audio-player"
    class="audio-player">
		<audio
			ref="audio"
			class="audio-controller"
      preload
      :src="src">
      </audio>
    <audio-control
      @click.stop
      @changeChapter="changeChapter"
      ref="control"
      :hasBuy="hasBuy"
      :title="title"
      :buffered="buffered"
      :currentTime="currentTime"
      :duration="length"
      :playing="playing"
      :clickPlay="clickPlay"
      :audioLoading="audioLoading"
      :isSeepWidth="isSeepWidth"
      @play="play"
      @speedChange="speedChange"
      @seek="seek" 
      :switchPlayingStatusType="switchPlayingStatusType"
      :playingStatusType="playingStatusType"
      />
    <!--<div class="audio-player-list" @click="changeStatus">-->
      <!--<div class="audio-player-list-main" @click.stop>-->
        <!--<audio-control-->
          <!--@click.stop-->
          <!--@changeChapter="changeChapter"-->
          <!--ref="control"-->
          <!--:hasBuy="hasBuy"-->
          <!--:title="title"-->
          <!--:buffered="buffered"-->
          <!--:currentTime="currentTime"-->
          <!--:duration="length"-->
          <!--:playing="playing"-->
          <!--:clickPlay="clickPlay"-->
          <!--:audioLoading="audioLoading"-->
          <!--:is-timer-right="isTimerRight"-->
          <!--@play="play"-->
          <!--@speedChange="speedChange"-->
          <!--@seek="seek"></audio-control>-->
        <!--<slot></slot>-->
      <!--</div>-->
    <!--</div>-->

    <!--<audio-cycle-->
      <!--v-show="!isControllerShow"-->
      <!--:playStatus="playing"-->
      <!--:teacher="teacher"-->
      <!--:currentTime="currentTime"-->
      <!--:duration="length"-->
      <!--:ended="ended"-->
      <!--:src="src"-->
      <!--@changeStatus="changeStatus"-->
      <!--@play="play">-->
    <!--</audio-cycle>-->
	</div>
</template>

<script>
// import { NativeMediaReporter } from '@edu-fe/reporter'
// import AudioCycle from './AudioCycle/index'
import AudioControl from './audio-control/index.vue'
import { setTimeout } from 'timers'
import api from '@edu-fe/api'
import record, {clearTimer} from '../../lib/record'
import barBus from '../../bar/bus'
import module from '../../modules/audio-detail'
import { mapState, mapActions } from 'vuex'
import keys from 'lodash.keys'
import login from '@/utils/login'
import courseModul from '../../modules/mediaCourse'
const os = require('@edu-fe/os-app')
const main = document.getElementById('video-mp4')

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      require: true
    },
    playedTime: {
      type: Number,
      default: 0
    },
    length: {
      type: Number,
      default: 0
    },
    teacher: {
      type: String,
      default: ''
    },
    quickChapterList: {
      type: Array,
      default: []
    },
    hasBuy: {
      type: Boolean,
      default: false
    },
    currentChapterIndex: {
      type: Number
    },
    handleAudioPlay: {
      type: Function,
      default: () => console.log('获取音频---')
    },
    switchPlayingStatusType: {
      type: Function,
      default: () => console.log('切换播放状态')
    },
    playingStatusType: {
      type: Number,
      default: ''
    },
    monitorAudioEnded: {
      type: Function,
      default: () => console.log('循环循环再循环')
    },
    answerChapter: {
      type: Function,
      default: () => console.log('切换音频')
    }
  },
  data () {
    return {
      isTimeSetted: false, // 设置初始播放时间
      fullStyle: false,
      fulling: false, // 正在全屏
      playing: false, // 正在播放
      started: false, // 开始播放
      showFull: true, // 展示全屏按钮
      currentTime: 0,
      duration: 0,
      buffered: 0,
      fullTimer: null,
      controllShow: true,
      // isTimerRight: '', // 控制时间空间展示位置
      /**
       * 缓存需要用到的dom
       */
      timerDom: null,
      lineDom: null,
      audioLoading: true,
      clickPlay: false,
      isControllerShow: false,
      ended: false,
      clickFlag: false,
      playStatus: false,
      isSeepWidth: false
      
    }
  },
  computed: {
    ...mapState(module.name, keys(module.modules)),
    player () {
      return this.$refs.audio
    }
  },
  watch: {
    // 切换播放地址时停止播放
    'src' () {
      // this.stop()
      this.isTimeSetted = false
      this.playing = false
      this.handleAudioPlay(false)
      setTimeout(() => {
        this.play()
      }, 50)
    },

    playing(value) {
      this.handleAudioPlay(value)
    },

    playedTime (value) {
      this.currentTime = value
      this.setTimerPosition()
    }
  },
  methods: {
    ...mapActions(module.name, keys(module.actions)),
    changeChapter (flag) {
      if (this.playingStatusType !== ''){
        this.answerChapter(flag)
        return
      }
      if (this.clickFlag) return
      clearTimer()
      this.stop()
      this.clickFlag = true
      setTimeout(() => {
        this.clickFlag = false
      }, 800)
      if (flag) {
        if (!this.quickChapterList[1]) {
          this.$toast.show({
            message: '当前已是最后一章'
          })
          return
        }
        this.$emit('selectChapter', this.quickChapterList[1], this.currentChapterIndex + 1)
        return
      }
      if (!this.quickChapterList[0]) {
        this.$toast.show({
          message: '当前已是第一章'
        })
        return
      }
      this.$emit('selectChapter', this.quickChapterList[0], this.currentChapterIndex - 1)
    },
    speedChange (item) {
      this.player.playbackRate = Number(item)
      this.player.defaultPlaybackRate =  Number(item)
    },
    changeStatus () {
      setTimeout(() => {
        barBus.$emit('scrollList')
      }, 0)
      this.isControllerShow = !this.isControllerShow
    },
    // 开始播放
    start () {
      if (this.started) {
        this.player.play()
      } else {
        this.started = true
        this.player.src = this.src
        this.player.play()
      }
    },
    // 播放
    play () {
      // if (this.audioLoading) {
      //   return
      // }
      this.ended = false
      this.clickPlay = true
      this.player[this.player.paused ? 'play' : 'pause']()
      this.playStatus = true
    },
    // 暂停
    pause () {
      if (this.player && !this.player.paused) {
        this.player.pause()
        this.playStatus = false
      }
    },
    resize () {
      if (this.player) {
        if (this.player.width() !== main.offsetWidth) { this.player.width(main.offsetWidth) }
        if (this.player.height() !== main.offsetHeight) { this.player.height(main.offsetHeight) }
      }
    },
    // 停止
    stop () {
      this.pause()
      this.started = false
      this.playing = false
    },
    // 指定
    seek (data) {
      this.player.currentTime = data.time
      this.setTimerPosition()
    },
    setTimerPosition () {
      setTimeout(() => {
        // if (this.lineDom.offsetWidth > (this.timerDom.offsetWidth - 50)) {
        //   this.isTimerRight = true
        // } else {
        //   this.isTimerRight = false
        // }
        if ((this.boxDom.offsetWidth - this.lineDom.offsetWidth) < this.timerDom.offsetWidth) {
          this.isSeepWidth = true
          // this.isTimerRight = false
        } else {
          this.isSeepWidth = false
        }
      }, 200)
    }
  },
  components: {
    AudioControl,
    // AudioCycle
  },

  mounted () {
    this.handleAudioPlay(false)
    // 判断时间控件应该如何展示, 缓存相关dom
    this.timerDom = this.$el.querySelector('.timer')
    this.boxDom = this.$el.querySelector('.audio-control-line')
    this.lineDom = this.$el.querySelector('.audio-control-line-current')
  
    // 上报学习进度
    this.$ne
    const player = this.player
    const chapterId = this.$route.query.chapterId
    record.report({
      el: player,
      chapterId,
      wpsSid: login.getWpsSid()
    })

    window.addEventListener('resize', () => {
      if (os.type === 'app' && os.name === 'wpsIos') return

      if (window.innerWidth > window.innerHeight) {
        this.fullStyle = true
      } else {
        this.fullStyle = false
      }
    })

    this.player.addEventListener('canplaythrough', () => {
      this.audioLoading = false
    }, false)

    this.player.addEventListener('playing', () => {
      this.playing = true
      this.$emit('playing')
    }, false)

    this.player.addEventListener('play', () => {
      this.$emit('play')
    }, false)

    this.player.addEventListener('pause', () => {
      this.playing = false
      this.$emit('pause')
    }, false)

    this.player.addEventListener('timeupdate', () => {
      try {
        this.buffered = Math.ceil(this.player.buffered.end(0))
      } catch (e) {}
      // 设置一次初始时间
      if (!this.isTimeSetted) {
        this.currentTime = this.playedTime
        this.player.currentTime = this.playedTime
        this.isTimeSetted = true
        this.setTimerPosition()
      } else {
        this.currentTime = this.player.currentTime
        if (!this.duration) {
          this.duration = this.player.duration
        }
      }

      this.setTimerPosition()
    }, false)

    if (this.playingStatusType !== '') {
      this.player.addEventListener('loadedmetadata', () => {
        this.length = parseInt(this.player.duration)
      })
    }

    this.player.addEventListener('ended', () => {
      // this.isSeepWidth = false
      this.playing = false
      // this.isTimerRight = false
      this.ended = true
      if (this.playingStatusType !== '') {
        this.monitorAudioEnded()
        if (this.playingStatusType == 3) {
          this.play()
        }
      }
    })
    // 资源加载失败 PS:公司资源封锁疯狂调用电脑扛不住 加个延迟...
    this.player.addEventListener('error', err => {
      this.$emit('error', err)
      // setTimeout(() => {
        // this.player.load()
      // }, 500);
    })
  },
  beforeDestroyed () {
    this.player.pause()
  },
  destroyed () {
    this.player = null
  }
}
</script>

<style lang="scss">
@charset "utf-8";
@import "../../style/main";

$global-width: 750;

.audio-player {
  /*position: fixed;*/
  /*right: 0;*/
  /*bottom: 0;*/
  /*left: 0;*/
  /*z-index: 1000;*/
  // height: rem($g-player);
  /*padding: rem(20) 0;*/
  /*height: rem(100);*/
  /*border-top: 1px solid #ececec;*/
  /*background-color: #fff;*/
  &-list {
    &-main {
      /*padding: rem(50) rem(30);*/
      /*box-sizing: border-box;*/
      /*position: fixed;*/
      /*width: 100%;*/
      /*height: rem(960);*/
      /*bottom: 0;*/
      /*left: 0;*/
      /*background: #fff;*/
      /*border-top-left-radius: rem(30);*/
      /*border-top-right-radius: rem(30);*/
    }
  }
  &-main {
    @include afull;
    background-color: #000;
  }

  &-full {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999999999999; //$z-index-full;
    overflow: hidden;
  }
}

$global-width: 720;
</style>
